import "../../css/Settings.module.css"
import { Link } from "react-router-dom"
const SettingsHeader = () => (
  <div className="settings-header">
    <h1 className="settings-title">تنظیمات</h1>
  </div>
)

const NotificationSettings = () => (
  <div className="settings-section card">
    <h2>تنظیمات اعلان‌ها</h2>
    <div className="settings-option">
      <label htmlFor="email-notifications">اعلان‌های ایمیلی</label>
      <input type="checkbox" id="email-notifications" />
    </div>
    <div className="settings-option">
      <label htmlFor="sms-notifications">اعلان‌های پیامکی</label>
      <input type="checkbox" id="sms-notifications" />
    </div>
  </div>
)

const PrivacySettings = () => (
  <div className="settings-section card">
    <h2>تنظیمات حریم خصوصی</h2>
    <div className="settings-option">
      <label htmlFor="profile-visibility">نمایش پروفایل برای</label>
      <select id="profile-visibility">
        <option value="public">همه</option>
        <option value="friends">دوستان</option>
        <option value="private">فقط خودم</option>
      </select>
    </div>
  </div>
)

const AccountSettings = () => (
  <div className="settings-section card">
    <h2>تنظیمات حساب کاربری</h2>
    <button className="action-button">تغییر رمز عبور</button>
    <button className="action-button">تغییر آدرس ایمیل</button>
    <button className="action-button danger">غیرفعال کردن حساب کاربری</button>
  </div>
)
const StudentActions = () => {
  const actions = [
    {
      id: 1,
      label: "بازگشت به داشبورد",
      icon: "fas fa-book",
      link: "/dashboard",
    },
    // {
    //   id: 2,
    //   label: "پیام به استاد",
    //   icon: "fas fa-comment",
    //   link: "/dashboard/messages",
    // },
    // {
    //   id: 3,
    //   label: "تنظیمات",
    //   icon: "fas fa-tasks",
    //   link: "/dashboard/settings",
    // },
    {
      id: 4,
      label: "پروفایل من",
      icon: "fas fa-certificate",
      link: "/dashboard/profile",
    },
  ];


  return (
    <div className="card">
      <h2>دسترسی سریع</h2>
      {actions.map((action, index) => (
        <Link to={action.link}><button key={index} className="action-button">
          <i className={action.icon}></i> {/* آیکون مربوط به هر عمل */}
          {action.label}
        </button></Link>
      ))}
    </div>
  );
};

const Settings = () => {
  return (
    <div className="settings-page">
      <SettingsHeader />
      <div className="d-flex seting-count">
        <StudentActions/>
        <div className="settings-content">
          <NotificationSettings />
          <PrivacySettings />
          <AccountSettings />
        </div>
      </div>
    </div>
  )
}

export default Settings

